import { Stack } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import { PAGINATION_MIN_HEIGHT } from './pagination.constants';

import { Button } from '../../inputs/button';

export type IPaginationProps = {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  requestNextPage: () => void;
  requestPreviousPage: () => void;
};

export const Pagination = (props: IPaginationProps) => {
  const { hasNextPage, hasPreviousPage, requestPreviousPage, requestNextPage } = props;

  return (
    <Stack
      direction='row'
      alignItems='center'
      ml={2}
      justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
      spacing={1}
      minHeight={PAGINATION_MIN_HEIGHT}
      pr={2}
    >
      <Button
        size='small'
        startIcon={<KeyboardArrowLeftIcon />}
        onClick={requestPreviousPage}
        disabled={!hasPreviousPage}
      >
        prev
      </Button>
      <Button
        size='small'
        endIcon={<KeyboardArrowRightIcon />}
        onClick={requestNextPage}
        disabled={!hasNextPage}
      >
        next
      </Button>
    </Stack>
  );
};
